package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProductSets(
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("name")
    val name: String?,
    @SerialName("checkOutCommandId")
    val checkOutCommandId: String?,
    @SerialName("sets")
    val sets: List<SetModel>,
    @SerialName("priceDiffMode")
    val priceDiffMode: String?,
    @SerialName("setsMode")
    val setsMode: String?,
    @SerialName("fixProductsAutoSelect")
    val fixProductsAutoSelect: Boolean?,
    @SerialName("isPricesNormalByDefaultInSet")
    val isPricesNormalByDefaultInSet: Boolean?,
    @SerialName("isMenuName")
    val isMenuName: Boolean?,
    @SerialName("__typename")
    val typename: String?
)